/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type EnumPersonaFisicaRequestDTORuolo =
  (typeof EnumPersonaFisicaRequestDTORuolo)[keyof typeof EnumPersonaFisicaRequestDTORuolo];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EnumPersonaFisicaRequestDTORuolo = {
  VIEWER: 'VIEWER',
  TITOLARE: 'TITOLARE',
  EDITOR: 'EDITOR',
} as const;
